import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/about/page.tsx");
